
export enum SettingNames {
	AllowExpedite = "Allow Expedited Applications"
}

export interface SystemSetting {
	lastModifiedBy: string;
	lastModifiedDate: Date;
	id: number;
	isActive?: boolean;
	settingName: string;
	settingState: string;
	systemSettingOptions?: SystemSettingOption[]
}

export interface SystemSettingOverTime {
	id?: number;
	settingName?: string;
	isActive?: boolean;
	settingState?: string;
	lastModifiedDate?: Date;
	lastModifiedBy?: Date;
	validFrom?: Date;
	validTo?: Date;
}

export interface SystemSettingOption {
	id: number;
	settingId: number;
	optionValue: string;
	optionDisplay: string;
}


export interface SystemSettingSearchSpec {
	settingName: SettingNames;
}

export interface UpdateSettingRequest {
	settings: SystemSetting[];
}